import Button from '@/components/Button/Button';
import useChartExport from '@/features/(charts)/chart-detail/hooks/use-chart-export';

type Props = {
  chartInfo: ChartContextProps;
};

export const ChartCandidateExportButton = ({ chartInfo }: Props) => {
  const { state, title } = chartInfo;
  const tableData = chartInfo.tableQuery.data;
  const handleExport = useChartExport({
    chartBase: state,
    tableData: tableData,
    title: title,
  });

  return (
    <Button variant="outlined" onClick={handleExport}>
      Export data
    </Button>
  );
};
